import { createTheme } from '@mui/material/styles'
import { border } from './border'
import { typography } from './typography'
import { surface } from './semanticTokens'

const material = createTheme()

export const RaGlobalRoot = {
  [material.breakpoints.up('md')]: {
    width: '100%',
  },
  ['& .MuiToolbar-root']: {
    alignItems: 'center',
    display: 'flex',
    fontFamily: typography.headline,
    minHeight: 'auto',
    backgroundColor: surface.white,
    borderRadius: 0,
    borderBottom: border.thin + ' solid ' + border.light,
  },
}
